<template>
  <sweet-modal ref="social_proofs_select" width="700px" :title="$t('ct-social-proof-settings')">
    <template v-if="socialproof_campaigns.length > 0 && internal_config">
      <div class="form-group">
        <label for="sp_campaign">{{ $t('ct-social-proof-campaign')}}</label>
        <select name="sp_campaign"
                id="sp_campaign"
                class="form-control"
                ref="social-proof-campaign"
                v-model="internal_config.socialproof_campaign_id"
        >
          <option value="0" disabled>{{ $t('ct-social-proof-select')}}</option>
          <option v-for="(campaign, index) in socialproof_campaigns" :value="campaign.id" :key="index">{{campaign.name}}
          </option>
        </select>
      </div>

      <div class="form-group" v-if="internal_config[key] && parseInt(internal_config.socialproof_campaign_id)">
        <label for="sp_user_name_tag">{{ $t('ct-social-proof-tag')}}</label>
        <select name="sp_user_name_tag"
                id="sp_user_name_tag"
                class="form-control"
                v-model="internal_config.socialproof_user_name_tag"
        >
          <option value="0" disabled>{{ $t('ct-social-proof-select-tag')}}</option>
          <option v-for="(inputList, index) in internal_config[key].filter(field => field.visibility !== 'hidden')" :value="inputList.tag" :key="index">{{inputList.label}} - {{inputList.tag}}</option>
        </select>
      </div>

    </template>

    <template v-else>{{ $t('ct-social-proof-empty-campaign')}}</template>

    <alert-box-component>
      <p slot="content">
        {{ $t(`ct-sp-${name}-helper`)}}
      </p>
    </alert-box-component>

    <a :href="`${officeDomain}/br/office/new-social-proof`" target="_blank" slot="button"
       class="btn btn-primary float-left m-0"><i class="svg-icon svgi-social-proof svgi-gray-light"/>{{ $t('ct-goto-social-proof')}}</a>

    <button slot="button" class="btn btn-secondary px-2 mx-2 float-left"
            v-tooltip.bottom="{ content:$t('ct-sp-sync'), class: 'tooltip-custom'}" @click="updateCampaigns"><i
      class="mdi mdi-sync font-awesome-icon"/></button>

    <button slot="button" class="btn btn-outline-light" @click="$refs.social_proofs_select.close()">{{ $t('ct-cancel')}}</button>
    <button slot="button" class="btn btn-success" @click="saveSocialProof"><i class="svg-icon svgi-save svgi-lg"></i>{{ $t('ct-save')}}</button>
  </sweet-modal>

</template>

<script>
import {SweetModal} from 'sweet-modal-vue';
import AlertBoxComponent from '../../../../commons/AlertBoxComponent';
import {getAllCampaigns} from '../../../../../js/services/integrations-internas/socialProof';

export default {
  name: 'ConfigSocialProof',
  components: {
    SweetModal,
    AlertBoxComponent
  },
  data() {
    return {
      key: false, // key for fields
      name: false,
      internal_config: false,
      callback: false,
      socialproof_campaigns_all: [],
      socialproof_campaigns: [],
      officeDomain: ''
    };
  },

  methods: {

    init(config, name, key, callback = false) {
      this.internal_config = config;
      this.name = name;
      this.key = key;
      this.callback = callback;
    },

    open() {

      if (this.name === 'simple-form') {
        this.socialproof_campaigns = [...this.socialproof_campaigns_all.filter(campaign => campaign.type === 'contact_form')];
      } else {
        this.socialproof_campaigns = [...this.socialproof_campaigns_all.filter(campaign => campaign.type === 'mailingboss')];
      }
      this.$refs.social_proofs_select.open();
    },

    updateCampaigns() {

      this.$loading.show();

      getAllCampaigns()
        .then(res => {
          if (!res.data.error && res.data.data) {
            this.socialproof_campaigns_all = res.data.data.data;

            if (this.name) {
              if (this.name === 'simple-form') {
                this.socialproof_campaigns = [...this.socialproof_campaigns_all.filter(campaign => campaign.type === 'contact_form')];
              } else {
                this.socialproof_campaigns = [...this.socialproof_campaigns_all.filter(campaign => campaign.type === 'mailingboss')];
              }
            }
          }
        })
        .catch(error => {
          console.error('error', error);
        })
        .finally(() => this.$loading.hide());
    },

    saveSocialProof() {
      let socialproofCampaingId = this.$refs['social-proof-campaign'].selectedOptions[0].value;

      if (socialproofCampaingId) {
        this.internal_config.socialproof_campaign_id = socialproofCampaingId;

        if (parseInt(socialproofCampaingId) && this.internal_config.socialproof_user_name_tag === '0') { return }

        if (this.callback && typeof this.callback === 'function') {
          this.callback(this.internal_config);
        }

        this.$refs['social_proofs_select'].close();
      }
    }
  },
  created() {
    this.updateCampaigns();
    this.officeDomain = typeof process.env.OFFICE_URL !== 'undefined' ? process.env.OFFICE_URL : 'https://office.builderall.com';
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Forms/SocialProof/ConfigSocialProof.vue